import { Filter } from '@anytag/shared-molecules';
import { BasicFilter } from './BasicFilter';
import { useCampaignPostsDiscoveryFilter } from './hooks';

export const CampaignPostsDiscoveryFilter = () => {
  const { filter, setFilterForm } = useCampaignPostsDiscoveryFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <BasicFilter />
    </Filter.Provider>
  );
};

export { useCampaignPostsDiscoveryFilter };
export * from './schemaTypes';
